<div class="card p-3"
     *adaptLoading="isLoading">
    <dx-chart (onInitialized)="onInitialized($event)"
              [hidden]="data.length === 0"
              [dataSource]="data"
              title="Career Valuations"
              [pathModified]="true"
              [customizePoint]="careerValuationUiService.customiseChartPoint"
              (onPointClick)="onPointClick($event)">
        <dxo-chart-size [height]="height"> </dxo-chart-size>
        <dxo-chart-margin [left]="20"
                          [right]="20"></dxo-chart-margin>
        <dxi-chart-series type="scatter"
                          valueField="score"
                          argumentField="argument"
                          tagField="careerValuation"></dxi-chart-series>
        <dxo-chart-argument-axis>
            <dxo-chart-grid [visible]="true"
                            [opacity]="0.2"> </dxo-chart-grid>
            <dxo-chart-label alignment="right"
                             format="monthAndYear"
                             overlappingBehavior="rotate"
                             [rotationAngle]="-45"
                             [visible]="showDates"></dxo-chart-label>
            <dxo-chart-minor-grid [visible]="false"> </dxo-chart-minor-grid>
        </dxo-chart-argument-axis>
        <dxo-chart-legend [visible]="false"></dxo-chart-legend>
        <dxo-chart-tooltip [enabled]="true"
                           [customizeTooltip]="customiseTooltip"></dxo-chart-tooltip>
        <dxi-chart-value-axis [tickInterval]="25"
                              [visualRange]="[0, 100]"
                              visualRangeUpdateMode="keep"
                              [valueMarginsEnabled]="false"
                              [visible]="true"></dxi-chart-value-axis>
        <dxo-chart-loading-indicator [enabled]="true"></dxo-chart-loading-indicator>
    </dx-chart>

    @if (data.length === 0) {
        <div>
            <adapt-no-cultural-measurement label="Career Valuations"></adapt-no-cultural-measurement>
        </div>
    }
</div>
